import environment from "environment";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import HttpUtility from "../../utilities/HttpUtility";
import { AxiosResponse } from "axios";
import EffectUtility from "../../utilities/EffectUtility";
import PreventivoModel from "./models/PreventivoModel";
import RicercaPreventivoViewModel from "./models/RicercaPreventivoViewModel";
import FormatUtility from "utilities/FormatUtility";
import ResponseEsitoModel from "stores/shared/models/ResponseEsitoModel";
import PreventiviUtenteModel from "./models/PreventiviUtenteModel";
import PreventivoQuestionarioModel from "./models/PreventivoQuestionarioModel";
import InfoUtentePreventivoModel from "./models/InfoUtentePreventivoModel";
import NuovoImpegnoModel from "./models/NuovoImpegnoModel";
import ConsensoPrivacyModel from "stores/consenso-privacy/models/ConsensoPrivacyModel";
import NuovoImpegnoViewModel from "./models/NuovoImpegnoViewModel";

export default class PreventivoEffect {
    public static async requestSimulazionePreventivos(
        filtri: RicercaPreventivoViewModel
    ): Promise<PreventiviUtenteModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.simulazionePreventivo;
        let request = {
            ...filtri,
            isLogged: filtri.isLogged ?? false,
            importoRichiesto: FormatUtility.numberFromNumberWithSeparators(filtri.importoRichiesto) ?? 0,
            codiceTipoRichiedente: filtri.codiceTipoRichiedente,
            dataNascita:
                filtri.dataNascita.length > 0
                    ? FormatUtility.dateInGivenFormat(filtri.dataNascita, "YYYY-MM-DD")
                    : null,
            dataAssunzione:
                filtri.dataAssunzione.length > 0
                    ? FormatUtility.dateInGivenFormat(filtri.dataAssunzione, "YYYY-MM-DD")
                    : null,
            importoNettoRedditoMensile:
                FormatUtility.numberFromNumberWithSeparators(filtri.importoNettoRedditoMensile) ?? 0,
            importoRata: filtri.importoRata,
            durata: filtri.durata,
            idPreventivo: filtri.idPreventivo,
            codiceConvenzione: filtri.codiceConvenzione,
            informazioniUtente: new InfoUtentePreventivoModel({
                ...filtri.informazioniUtente,
                idUtente: filtri.informazioniUtente.idUtente,
                nome: filtri.informazioniUtente.nome,
                cognome: filtri.informazioniUtente.cognome,
                privacy: [
                    ...filtri.informazioniUtente.privacy?.map(
                        (privacy) =>
                            new ConsensoPrivacyModel({
                                ...privacy,
                                descrizione: privacy.descrizione,
                                isObbligatorio: privacy.isObbligatorio,
                                codice: privacy.codice,
                                isAccettato: privacy.isAccettato,
                                fgMostraLanding: privacy.fgMostraLanding,
                            })
                    ),
                ],
                idPreventivo: filtri.informazioniUtente.idPreventivo,
                email: filtri.informazioniUtente.email,
                numeroTelefono: filtri.informazioniUtente.numeroTelefono,
            }),
            preventivoQuestionario: {
                //...filtri.preventivoQuestionario,
                categoriaAmministrativa: filtri.preventivoQuestionario.categoriaAmministrativa,
                amministrazione: filtri.preventivoQuestionario.amministrazione,
                descrizioneAmministrazione: filtri.preventivoQuestionario.decrizioneAmministrazione,
                fgAltriFinanziamenti: filtri.preventivoQuestionario.fgAltriFinanziamenti,
                altriImpegni: [
                    ...filtri.preventivoQuestionario.altriImpegni?.map(
                        (impegno: NuovoImpegnoViewModel) =>
                            ({
                                idImpegno: impegno.idImpegno,
                                idUtente: filtri.informazioniUtente.idUtente,
                                tipologiaImpegno: impegno.tipologiaImpegno,
                                fgPresenzaDati: impegno.fgPresenzaDati,
                                estinzione: impegno.estinzione,
                                rata: FormatUtility.numberFromNumberWithSeparators(impegno.rata) ?? 0,
                                durata: impegno.durata,
                                dataInizio:
                                    impegno.dataInizio.length > 0
                                        ? FormatUtility.dateInGivenFormat(impegno.dataInizio, "YYYY-MM-DD")
                                        : undefined,
                                tan: FormatUtility.numberFromNumberWithSeparators(impegno.tan) ?? 0,
                                dataChiusuraCe:
                                    impegno.dataChiusuraCe.length > 0
                                        ? FormatUtility.dateInGivenFormat(impegno.dataChiusuraCe, "YYYY-MM-DD")
                                        : null,
                                debitoResiduo: FormatUtility.numberFromNumberWithSeparators(impegno.debitoResiduo) ?? 0,
                                ordineInserimento: impegno.ordineInserimento,
                                istitutoFinanziario: impegno.istitutoFinanziario,
                                istitutoFinanziarioValore: impegno.istitutoFinanziarioValore,
                            } as NuovoImpegnoModel)
                    ),
                ] as NuovoImpegnoModel[],
            } as PreventivoQuestionarioModel,
        };
        // console.log("requestSimulazionePreventivos effetct ", request);
        return EffectUtility.postToModel<PreventiviUtenteModel>(PreventiviUtenteModel, endpoint, request);
    }

    public static async requestPreventivos(): Promise<PreventivoModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.preventivo;
        return EffectUtility.getToModel<PreventivoModel[]>(PreventivoModel, endpoint);
    }

    public static async savePreventivo(
        PreventivoModel: PreventivoModel
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.salvaPreventivo;

        const input: PreventivoModel = {
            ...PreventivoModel,
            dataAssunzione: PreventivoModel.dataAssunzione.length > 0 ? PreventivoModel.dataAssunzione : null,
        } as PreventivoModel;
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, input);
    }

    public static async requestGetFiltri(): Promise<RicercaPreventivoViewModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getFiltriPreventivo;
        return EffectUtility.getToModel<RicercaPreventivoViewModel>(RicercaPreventivoViewModel, endpoint);
    }

    public static async setRegistrazioneAnonima(
        filtri: RicercaPreventivoViewModel
    ): Promise<RicercaPreventivoViewModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.registrazioneAnonima;
        let request = {
            ...filtri,
            isLogged: filtri.isLogged ?? false,
            importoRichiesto: FormatUtility.numberFromNumberWithSeparators(filtri.importoRichiesto) ?? 0,
            codiceTipoRichiedente: filtri.codiceTipoRichiedente,
            dataNascita:
                filtri.dataNascita.length > 0
                    ? FormatUtility.dateInGivenFormat(filtri.dataNascita, "YYYY-MM-DD")
                    : null,
            dataAssunzione:
                filtri.dataAssunzione.length > 0
                    ? FormatUtility.dateInGivenFormat(filtri.dataAssunzione, "YYYY-MM-DD")
                    : null,
            importoNettoRedditoMensile:
                FormatUtility.numberFromNumberWithSeparators(filtri.importoNettoRedditoMensile) ?? 0,
            importoRata: filtri.importoRata,
            durata: filtri.durata,
            idPreventivo: filtri.idPreventivo,
            codiceConvenzione: filtri.codiceConvenzione,
            informazioniUtente: new InfoUtentePreventivoModel({
                ...filtri.informazioniUtente,
                idUtente: filtri.informazioniUtente.idUtente,
                nome: filtri.informazioniUtente.nome,
                cognome: filtri.informazioniUtente.cognome,
                privacy: [
                    ...filtri.informazioniUtente.privacy?.map(
                        (privacy) =>
                            new ConsensoPrivacyModel({
                                ...privacy,
                                descrizione: privacy.descrizione,
                                isObbligatorio: privacy.isObbligatorio,
                                codice: privacy.codice,
                                isAccettato: privacy.isAccettato,
                                fgMostraLanding: privacy.fgMostraLanding,
                            })
                    ),
                ],
                idPreventivo: filtri.informazioniUtente.idPreventivo,
                email: filtri.informazioniUtente.email,
                numeroTelefono: filtri.informazioniUtente.numeroTelefono,
            }),
            preventivoQuestionario: {
                //...filtri.preventivoQuestionario,
                categoriaAmministrativa: filtri.preventivoQuestionario.categoriaAmministrativa,
                amministrazione: filtri.preventivoQuestionario.amministrazione,
                descrizioneAmministrazione: filtri.preventivoQuestionario.decrizioneAmministrazione,
                fgAltriFinanziamenti: filtri.preventivoQuestionario.fgAltriFinanziamenti,
                altriImpegni: [
                    ...filtri.preventivoQuestionario.altriImpegni?.map(
                        (impegno: NuovoImpegnoViewModel) =>
                            ({
                                // ...impegno,
                                idImpegno: impegno.idImpegno,
                                idUtente: filtri.informazioniUtente.idUtente,
                                tipologiaImpegno: impegno.tipologiaImpegno,
                                fgPresenzaDati: impegno.fgPresenzaDati,
                                estinzione: impegno.estinzione,
                                rata: FormatUtility.numberFromNumberWithSeparators(impegno.rata) ?? 0,
                                durata: impegno.durata,
                                dataInizio:
                                    impegno.dataInizio.length > 0
                                        ? FormatUtility.dateInGivenFormat("01/" + impegno.dataInizio, "YYYY-MM-DD")
                                        : undefined,
                                tan: FormatUtility.numberFromNumberWithSeparators(impegno.tan) ?? 0,
                                dataChiusuraCe:
                                    impegno.dataChiusuraCe.length > 0
                                        ? FormatUtility.dateInGivenFormat(impegno.dataChiusuraCe, "YYYY-MM-DD")
                                        : null,
                                debitoResiduo: FormatUtility.numberFromNumberWithSeparators(impegno.debitoResiduo) ?? 0,
                                ordineInserimento: impegno.ordineInserimento,
                                istitutoFinanziario: impegno.istitutoFinanziario,
                                istitutoFinanziarioValore: impegno.istitutoFinanziarioValore,
                            } as NuovoImpegnoModel)
                    ),
                ] as NuovoImpegnoModel[],
            } as PreventivoQuestionarioModel,
        };
        return EffectUtility.postToModel<RicercaPreventivoViewModel>(RicercaPreventivoViewModel, endpoint, request);
    }
    /**
     * This is only to trigger an error api response so we can use it for an example in the AboutPage
     */
    public static async requestError(): Promise<any | HttpErrorResponseModel> {
        const endpoint: string = environment.api.errorExample;
        const response: AxiosResponse | HttpErrorResponseModel = await HttpUtility.get(endpoint);

        if (response instanceof HttpErrorResponseModel) {
            return response;
        }

        return response.data;
    }
}
